import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgEditSkull1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      fill="currentColor"
      d="M12 0a10.286 10.286 0 0 0-6.243 18.45 1.71 1.71 0 0 1 .672 1.36v1.619A2.57 2.57 0 0 0 9 24a1.714 1.714 0 0 0 1.714-1.714V21a1.286 1.286 0 0 1 2.572 0v1.286A1.714 1.714 0 0 0 15 24a2.57 2.57 0 0 0 2.571-2.571V19.81a1.71 1.71 0 0 1 .672-1.36A10.286 10.286 0 0 0 12 0M7.714 12.429a2.143 2.143 0 1 1 2.143-2.143 2.143 2.143 0 0 1-2.143 2.143m8.572 0a2.143 2.143 0 1 1 2.143-2.143 2.143 2.143 0 0 1-2.143 2.143"
    />
  </svg>
);
